<template>
  <ul class="ratings-circles">
    <li v-for="n in length" 
      :key="n" 
      class="circle" 
      :class="{
        filled: n <= rating,
        half: rating+.5 === n,
      }">
    </li>
  </ul>
</template>

<script> 
export default {
  name: 'Circles',
  props: {
    length: {
      type: Number,
      default: 5,
    },
    rating: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
  .ratings-circles {
    margin: 0;
  }
  .circle {
    display: inline-block;
    width: 14px;
    height: 14px;
    background-image: url(../../assets/star-empty.png);
    background-repeat: no-repeat;
    background-size: 14px auto;
    &.filled {
      background-image: url(../../assets/star-full.png);
    }
    &.half {
      background-image: url(../../assets/star-half.png);
    }
  }
</style>
